import { forwardRef, type SVGProps } from 'react';

export const Mobile = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg {...props} ref={ref} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 0H7a3 3 0 00-3 3v18a3 3 0 003 3h10a3 3 0 003-3V3a3 3 0 00-3-3zM6 19V3.5a.5.5 0 01.5-.5h11a.5.5 0 01.5.5V19a.5.5 0 01-.5.5h-11A.5.5 0 016 19z"
      fill="currentColor"
    />
  </svg>
));
